import { removeServerPreview } from "src/utils/serverPreview";

/*
 * Rendered by the root Bugsnag error boundary, which otherwise has no fallback
 * and so renders `null` — turning any uncaught render error into a blank page.
 *
 * This is the one component that runs while the app is known to be broken, so it
 * deliberately uses plain elements and inline styles rather than the component
 * library: a fallback that fails for the same reason as the thing it is catching
 * is not a fallback.
 */
export const AppErrorFallback = () => (
  <div
    ref={removeServerPreview}
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "16px",
      minHeight: "100vh",
      padding: "24px",
      textAlign: "center",
      fontFamily: "Helvetica, Arial, sans-serif",
      color: "#000",
      background: "#fff",
    }}
  >
    <h1 style={{ fontSize: "24px", fontWeight: 700, margin: 0 }}>
      Something went wrong
    </h1>
    <p style={{ fontSize: "16px", lineHeight: 1.5, margin: 0, maxWidth: 420 }}>
      Sorry, this page didn&apos;t load properly. Reloading usually fixes it.
    </p>
    <button
      type="button"
      onClick={() => window.location.reload()}
      style={{
        cursor: "pointer",
        padding: "12px 24px",
        fontSize: "16px",
        fontWeight: 700,
        color: "#fff",
        background: "#000",
        border: "none",
        borderRadius: "4px",
      }}
    >
      Reload page
    </button>
  </div>
);
